import React from 'react';
import { 
  Building, 
  Shield, 
  Users, 
  TrendingUp, 
  CheckCircle, 
  Star,
  ArrowRight,
  Award,
  Target,
  Zap
} from 'lucide-react';

const Lending = () => {
  return (
    <>
      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
        padding: '6rem 0 4rem',
        position: 'relative',
        overflow: 'hidden',
        marginTop: '80px',
        '@media (max-width: 768px)': {
          padding: '4rem 0 3rem'
        }
      }}>
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          background: 'radial-gradient(circle at 30% 70%, rgba(255, 107, 53, 0.1) 0%, transparent 50%)',
          pointerEvents: 'none'
        }}></div>
        
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem', position: 'relative', zIndex: '1' }}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h1 style={{
              fontSize: '4rem',
              fontWeight: '900',
              color: 'white',
              marginBottom: '1.5rem',
              letterSpacing: '-0.02em',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
              '@media (max-width: 768px)': {
                fontSize: '3rem'
              },
              '@media (max-width: 480px)': {
                fontSize: '2.5rem'
              }
            }}>
              Our <span style={{
                background: 'linear-gradient(135deg, #ff6b35, #ff8c42)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>Lending Partners</span>
            </h1>
            <p style={{
              fontSize: '1.3rem',
              color: 'rgba(255, 255, 255, 0.9)',
              maxWidth: '700px',
              margin: '0 auto 2rem',
              lineHeight: '1.6',
              '@media (max-width: 768px)': {
                fontSize: '1.1rem'
              }
            }}>
              We work with trusted financial institutions and lending partners to provide you with the best loan options, competitive rates, and seamless borrowing experience.
            </p>
          </div>
        </div>
      </section>

      {/* Lending Partners Section */}
      <section style={{
        background: 'white',
        padding: '5rem 0',
        position: 'relative',
        '@media (max-width: 768px)': {
          padding: '3rem 0'
        }
      }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: '700',
              color: '#1e293b',
              marginBottom: '1rem',
              '@media (max-width: 768px)': {
                fontSize: '2rem'
              }
            }}>
              Trusted Lending Partners
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: '#64748b',
              maxWidth: '600px',
              margin: '0 auto',
              '@media (max-width: 768px)': {
                fontSize: '1rem'
              }
            }}>
              Our network of verified lending partners ensures you get access to the most competitive rates and flexible terms.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem',
            marginBottom: '4rem',
            '@media (max-width: 768px)': {
              gridTemplateColumns: '1fr',
              gap: '1.5rem'
            }
          }}>
            {/* Partner 1 */}
            <div style={{
              background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
              padding: '2.5rem',
              borderRadius: '16px',
              border: '1px solid #e2e8f0',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
              position: 'relative',
              overflow: 'hidden'
            }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-8px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
              <div style={{
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                height: '4px',
                background: 'linear-gradient(90deg, #1e40af, #3b82f6)',
                zIndex: '1'
              }}></div>
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, #1e40af, #3b82f6)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem',
                color: 'white',
                boxShadow: '0 4px 16px rgba(30, 64, 175, 0.3)'
              }}>
                <Building size={32} />
              </div>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#1e293b',
                marginBottom: '1rem'
              }}>
                Premier NBFC
              </h3>
              <p style={{
                color: '#64748b',
                fontSize: '1rem',
                lineHeight: '1.6',
                marginBottom: '1.5rem'
              }}>
                Licensed Non-Banking Financial Company providing personal loans with competitive interest rates starting from 12% per annum.
              </p>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                color: '#1e40af',
                fontWeight: '600',
                fontSize: '0.9rem'
              }}>
                {/* <span>Learn More</span>
                <ArrowRight size={16} /> */}
              </div>
            </div>

            {/* Partner 2 */}
            <div style={{
              background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
              padding: '2.5rem',
              borderRadius: '16px',
              border: '1px solid #e2e8f0',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
              position: 'relative',
              overflow: 'hidden'
            }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-8px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
              <div style={{
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                height: '4px',
                background: 'linear-gradient(90deg, #059669, #10b981)',
                zIndex: '1'
              }}></div>
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, #059669, #10b981)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem',
                color: 'white',
                boxShadow: '0 4px 16px rgba(5, 150, 105, 0.3)'
              }}>
                <Shield size={32} />
              </div>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#1e293b',
                marginBottom: '1rem'
              }}>
                Digital Bank Partner
              </h3>
              <p style={{
                color: '#64748b',
                fontSize: '1rem',
                lineHeight: '1.6',
                marginBottom: '1.5rem'
              }}>
                Modern digital banking solutions with instant loan approvals and flexible repayment options tailored to your needs.
              </p>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                color: '#059669',
                fontWeight: '600',
                fontSize: '0.9rem'
              }}>
                {/* <span>Learn More</span>
                <ArrowRight size={16} /> */}
              </div>
            </div>

            {/* Partner 3 */}
            <div style={{
              background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
              padding: '2.5rem',
              borderRadius: '16px',
                border: '1px solid #e2e8f0',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
              position: 'relative',
              overflow: 'hidden'
            }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-8px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
              <div style={{
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                height: '4px',
                background: 'linear-gradient(90deg, #dc2626, #ef4444)',
                zIndex: '1'
              }}></div>
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, #dc2626, #ef4444)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem',
                color: 'white',
                boxShadow: '0 4px 16px rgba(220, 38, 38, 0.3)'
              }}>
                <TrendingUp size={32} />
              </div>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#1e293b',
                marginBottom: '1rem'
              }}>
                Fintech Innovator
              </h3>
              <p style={{
                color: '#64748b',
                fontSize: '1rem',
                lineHeight: '1.6',
                marginBottom: '1.5rem'
              }}>
                Cutting-edge financial technology company offering AI-powered loan assessment and instant disbursement solutions.
              </p>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                color: '#dc2626',
                fontWeight: '600',
                fontSize: '0.9rem'
              }}>
                {/* <span>Learn More</span>
                <ArrowRight size={16} /> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Our Partners Section */}
      <section style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        padding: '5rem 0',
        position: 'relative',
        overflow: 'hidden',
        '@media (max-width: 768px)': {
          padding: '3rem 0'
        }
      }}>
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          background: 'radial-gradient(circle at 70% 30%, rgba(30, 64, 175, 0.05) 0%, transparent 50%)',
          pointerEvents: 'none'
        }}></div>
        
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem', position: 'relative', zIndex: '1' }}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: '700',
              color: '#1e293b',
              marginBottom: '1rem',
              '@media (max-width: 768px)': {
                fontSize: '2rem'
              }
            }}>
              Why Choose Our Lending Partners?
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: '#64748b',
              maxWidth: '600px',
              margin: '0 auto',
              '@media (max-width: 768px)': {
                fontSize: '1rem'
              }
            }}>
              We carefully select our lending partners based on their reputation, competitive rates, and commitment to customer satisfaction.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '2rem',
            '@media (max-width: 768px)': {
              gridTemplateColumns: '1fr',
              gap: '1.5rem'
            }
          }}>
            <div style={{
              background: 'white',
              padding: '2rem',
              borderRadius: '16px',
              border: '1px solid #e2e8f0',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
            }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-4px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
              <div style={{
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, #1e40af, #3b82f6)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem',
                color: 'white'
              }}>
                <CheckCircle size={24} />
              </div>
              <h4 style={{
                fontSize: '1.2rem',
                fontWeight: '600',
                color: '#1e293b',
                marginBottom: '0.5rem'
              }}>
                Verified & Licensed
              </h4>
              <p style={{
                color: '#64748b',
                fontSize: '0.9rem',
                lineHeight: '1.5',
                margin: '0'
              }}>
                All our partners are RBI-licensed and thoroughly vetted for compliance and reliability.
              </p>
            </div>

            <div style={{
              background: 'white',
              padding: '2rem',
              borderRadius: '16px',
              border: '1px solid #e2e8f0',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
            }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-4px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
              <div style={{
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, #059669, #10b981)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem',
                color: 'white'
              }}>
                <Star size={24} />
              </div>
              <h4 style={{
                fontSize: '1.2rem',
                fontWeight: '600',
                color: '#1e293b',
                marginBottom: '0.5rem'
              }}>
                Competitive Rates
              </h4>
              <p style={{
                color: '#64748b',
                fontSize: '0.9rem',
                lineHeight: '1.5',
                margin: '0'
              }}>
                Access to the most competitive interest rates in the market through our partner network.
              </p>
            </div>

            <div style={{
              background: 'white',
              padding: '2rem',
              borderRadius: '16px',
              border: '1px solid #e2e8f0',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
            }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-4px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
              <div style={{
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, #dc2626, #ef4444)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem',
                color: 'white'
              }}>
                <Zap size={24} />
              </div>
              <h4 style={{
                fontSize: '1.2rem',
                fontWeight: '600',
                color: '#1e293b',
                marginBottom: '0.5rem'
              }}>
                Fast Processing
              </h4>
              <p style={{
                color: '#64748b',
                fontSize: '0.9rem',
                lineHeight: '1.5',
                margin: '0'
              }}>
                Quick loan approval and disbursement processes to meet your urgent financial needs.
              </p>
            </div>

            <div style={{
              background: 'white',
              padding: '2rem',
              borderRadius: '16px',
              border: '1px solid #e2e8f0',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
            }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-4px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
              <div style={{
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, #7c3aed, #a855f7)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem',
                color: 'white'
              }}>
                <Users size={24} />
              </div>
              <h4 style={{
                fontSize: '1.2rem',
                fontWeight: '600',
                color: '#1e293b',
                marginBottom: '0.5rem'
              }}>
                Expert Support
              </h4>
              <p style={{
                color: '#64748b',
                fontSize: '0.9rem',
                lineHeight: '1.5',
                margin: '0'
              }}>
                Dedicated customer support team to guide you through the entire loan process.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Partnership Benefits Section */}
      <section style={{
        background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
        padding: '5rem 0',
        position: 'relative',
        overflow: 'hidden',
        '@media (max-width: 768px)': {
          padding: '3rem 0'
        }
      }}>
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          background: 'radial-gradient(circle at 30% 70%, rgba(255, 107, 53, 0.1) 0%, transparent 50%)',
          pointerEvents: 'none'
        }}></div>
        
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem', position: 'relative', zIndex: '1' }}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: '700',
              color: 'white',
              marginBottom: '1rem',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
              '@media (max-width: 768px)': {
                fontSize: '2rem'
              }
            }}>
              Partnership Benefits
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: 'rgba(255, 255, 255, 0.9)',
              maxWidth: '600px',
              margin: '0 auto',
              '@media (max-width: 768px)': {
                fontSize: '1rem'
              }
            }}>
              Our strategic partnerships with leading financial institutions ensure you get the best possible loan terms and service.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem',
            '@media (max-width: 768px)': {
              gridTemplateColumns: '1fr',
              gap: '1.5rem'
            }
          }}>
            <div style={{
              background: 'rgba(255, 255, 255, 0.95)',
              padding: '2.5rem',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
              backdropFilter: 'blur(10px)'
            }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-8px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
              <div style={{
                width: '70px',
                height: '70px',
                background: 'linear-gradient(135deg, #1e40af, #3b82f6)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem',
                color: 'white',
                boxShadow: '0 4px 16px rgba(30, 64, 175, 0.3)'
              }}>
                <Award size={32} />
              </div>
              <h3 style={{
                fontSize: '1.4rem',
                fontWeight: '700',
                color: '#1e293b',
                marginBottom: '1rem'
              }}>
                Best-in-Class Service
              </h3>
              <p style={{
                color: '#64748b',
                fontSize: '1rem',
                lineHeight: '1.6',
                margin: '0'
              }}>
                Our partners maintain the highest standards of customer service and loan processing excellence.
              </p>
            </div>

            <div style={{
              background: 'rgba(255, 255, 255, 0.95)',
              padding: '2.5rem',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
              backdropFilter: 'blur(10px)'
            }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-8px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
              <div style={{
                width: '70px',
                height: '70px',
                background: 'linear-gradient(135deg, #059669, #10b981)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem',
                color: 'white',
                boxShadow: '0 4px 16px rgba(5, 150, 105, 0.3)'
              }}>
                <Target size={32} />
              </div>
              <h3 style={{
                fontSize: '1.4rem',
                fontWeight: '700',
                color: '#1e293b',
                marginBottom: '1rem'
              }}>
                Tailored Solutions
              </h3>
              <p style={{
                color: '#64748b',
                fontSize: '1rem',
                lineHeight: '1.6',
                margin: '0'
              }}>
                Customized loan products designed to meet your specific financial requirements and goals.
              </p>
            </div>

            <div style={{
              background: 'rgba(255, 255, 255, 0.95)',
              padding: '2.5rem',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
              backdropFilter: 'blur(10px)'
            }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-8px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
              <div style={{
                width: '70px',
                height: '70px',
                background: 'linear-gradient(135deg, #dc2626, #ef4444)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem',
                color: 'white',
                boxShadow: '0 4px 16px rgba(220, 38, 38, 0.3)'
              }}>
                <Shield size={32} />
              </div>
              <h3 style={{
                fontSize: '1.4rem',
                fontWeight: '700',
                color: '#1e293b',
                marginBottom: '1rem'
              }}>
                Secure & Transparent
              </h3>
              <p style={{
                color: '#64748b',
                fontSize: '1rem',
                lineHeight: '1.6',
                margin: '0'
              }}>
                Complete transparency in terms and conditions with bank-level security for all transactions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        background: 'linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%)',
        padding: '4rem 0',
        textAlign: 'center',
        '@media (max-width: 768px)': {
          padding: '3rem 0'
        }
      }}>
        <div className="container" style={{ maxWidth: '800px', margin: '0 auto', padding: '0 2rem' }}>
          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: 'white',
            marginBottom: '1rem',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
            '@media (max-width: 768px)': {
              fontSize: '2rem'
            }
          }}>
            Ready to Get Started?
          </h2>
          <p style={{
            fontSize: '1.2rem',
            color: 'rgba(255, 255, 255, 0.9)',
            marginBottom: '2rem',
            lineHeight: '1.6',
            '@media (max-width: 768px)': {
              fontSize: '1.1rem'
            }
          }}>
            Connect with our lending partners and find the perfect loan solution for your needs.
          </p>
          <div style={{
            display: 'flex',
            justifyContent: 'center'
          }}>
            <button style={{
              background: 'white',
              color: '#4A7C59',
              border: 'none',
              padding: '1rem 2rem',
              borderRadius: '25px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 14px rgba(74, 124, 89, 0.2)'
            }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
              Apply for Loan
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Lending;
